const MyCourseActionTypes = {
	FETCH_ATTEMPT: {
		SUCCESS: 'FETCH_ATTEMPT_SUCCESS',
		FAILURE: 'FETCH_ATTEMPT_FAILURE',
		PENDING: 'FETCH_ATTEMPT_PENDING',
	},

	FETCH_INSTRUCTIONS: {
		PENDING: 'FETCH_INSTRUCTIONS_PENDING',
		SUCCESS: 'FETCH_INSTRUCTIONS_SUCCESS',
		FAILURE: 'FETCH_INSTRUCTIONS_FAILURE',
	},

	CHECK_SPEECH: {
		PENDING: 'CHECK_SPEECH_PENDING',
		SUCCESS: 'CHECK_SPEECH_SUCCESS',
		FAILURE: 'CHECK_SPEECH_FAILURE',
	},

	START_ATTEMPT: {
		PENDING: 'START_ATTEMPT_PENDING',
		SUCCESS: 'START_ATTEMPT_SUCCESS',
		FAILURE: 'START_ATTEMPT_FAILURE',
	},

	FETCH_COURSE_DETAILS: {
		PENDING: 'FETCH_COURSE_DETAILS_PENDING',
		SUCCESS: 'FETCH_COURSE_DETAILS_SUCCESS',
		FAILURE: 'FETCH_COURSE_DETAILS_FAILURE',
	},

	FETCH_TASK_DETAILS: {
		PENDING: 'FETCH_TASK_DETAILS_PENDING',
		SUCCESS: 'FETCH_TASK_DETAILS_SUCCESS',
		FAILURE: 'FETCH_TASK_DETAILS_FAILURE',
	},

	FETCH_CALL_HISTORY: {
		PENDING: 'FETCH_CALL_HISTORY_PENDING',
		SUCCESS: 'FETCH_CALL_HISTORY_SUCCESS',
		FAILURE: 'FETCH_CALL_HISTORY_FAILURE',
	},

	SUBMIT_ASSIGNMENT: {
		PENDING: 'SUBMIT_ASSIGNMENT_PENDING',
		SUCCESS: 'SUBMIT_ASSIGNMENT_SUCCESS',
		FAILURE: 'SUBMIT_ASSIGNMENT_FAILURE',
	},

	RESCHEDULE_CALL: {
		PENDING: 'RESCHEDULE_CALL_PENDING',
		SUCCESS: 'RESCHEDULE_CALL_SUCCESS',
		FAILURE: 'RESCHEDULE_CALL_FAILURE',
	},

	CHANGE_GRADE: {
		PENDING: 'CHANGE_GRADE_PENDING',
		SUCCESS: 'CHANGE_GRADE_SUCCESS',
		FAILURE: 'CHANGE_GRADE_FAILURE',
	},

	GENERATE_CERTIFICATE: {
		PENDING: 'GENERATE_CERTIFICATE_PENDING',
		SUCCESS: 'GENERATE_CERTIFICATE_SUCCESS',
		FAILURE: 'GENERATE_CERTIFICATE_FAILURE',
	},

	GET_UPNEXT: {
		PENDING: 'GET_UPNEXT_PENDING',
		SUCCESS: 'GET_UPNEXT_SUCCESS',
		FAILURE: 'GET_UPNEXT_FAILURE',
	},
	SET_PREVIEW_MODE: 'SET_PREVIEW_MODE',
	UPDATE_ACTIVE_COURSE: 'UPDATE_ACTIVE_COURSE',
	HANDLE_INPUT_CHANGE: 'HANDLE_INPUT_CHANGE',
	SET_CANCEL_REASON: 'SET_CANCEL_REASON',
	RESET_COURSE_ID: 'RESET_COURSE_ID',
	SET_INITIAL_COURSE_DETAILS: 'SET_INITIAL_COURSE_DETAILS',
	SET_SPEECH_STATUS: 'SET_SPEECH_STATUS',
	SET_FILE_VALUE: 'SET_FILE_VALUE',
	SET_FILE_ERROR: 'SET_FILE_ERROR',
	RESET_UNIT_ID: 'RESET_UNIT_ID',
	SET_SCHEDULE_ID: 'SET_SCHEDULE_ID',
	SET_SHOW_TESTINSTRUCTION: 'SET_SHOW_TESTINSTRUCTION',
	SET_ACTIVE_UNIT: 'SET_ACTIVE_UNIT',
	SET_SHOW_GRADE: 'SET_SHOW_GRADE',
	SET_SHOW_CANCEL_REASON: 'SET_SHOW_CANCEL_REASON',
	SET_SHOW_INFO: 'SET_SHOW_INFO',
};

export default MyCourseActionTypes;
